module.exports = __webpack_public_path__ + "img/119.fd1ecc7c.jpg";